import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Button, Dialog, DialogContent, DialogTitle, Divider, Grid, List, ListItemButton, Stack, Typography, ListItem, ListItemText, DialogActions, Box, Switch } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import close from "../../../asset/image/close.svg";
import _ from "lodash";
import ChangeSubOrg from '../ChangeSubOrgDialog/ChangeSubOrgPerServiceLine';
import { checkLoggedInUserAuthorizedToViewPage, getDataFromLocalStorage, getDecodeURI } from "../../../utils/util";
import PauseResumeServiceLine from './PauseResume';
import { getAvailableProductsForAccount, assignCustomPlan, updatePublicIP, getNonAdminPermissions, getTopUpProductIds, topUpStandardServiceLine, ACTION_TYPES, cancelScheduledPlan, getServicelineTerminalRouter } from "../slice";
import MobilePriority from "./MobilePriority";
import { STARLINK_ADMIN_SL_CHNAGE_SUB_ORG, STARLINK_ADMIN_PUBLIC_IP, STARLINK_ADMIN_SL_DETAILS, STARLINK_ADMIN_SL_TOP_UP, SERVICE_PLAN, STARLINK_ADMIN_DEVICES, STARLINK_ADMIN_SL_MOBILE_PRIORITY, STARLINK_ADMIN_SL_PAUSE_SERVICE_LINE, STARLINK_ADMIN_SL_RESUME_SERVICE_LINE, STARLINK_ADMIN_BETA_DEVICES } from "../../../utils/actionConstants";
import ServiceLineDetails from "./ServiceLineDetails";
import ServiceLineDevices from "./ServiceLineDevices";
import ServiceLineTopUp from "./ServiceLineTopUp";
import { SERVICE_FUNCTION_TO_FEATURE } from '../../../config';
import { getStarlinkMapTelemetry } from "../../StarlinkDashboard/slice";
import { USER_OU } from "../../../constants/Constants";
import "./ServiceLines.css"
import { toast } from 'react-toastify';
import ServicePlan from "./ServicePlan";
import TerminalRouters from "./TerminalRouters";
import DevicesTab from "./DeivecesTabNew";
var Loader = require("react-loader");

type SubscriptionOption = { label: string; name: string; data: any[]; plan_size?: string; unit?: string; isCustomPlan?: boolean; hasDivider?: boolean; };
type SubscriptionHeader = { label: string; name: string; data: []; plan_size?: string; unit?: string; };
type PlanDropdownOption = SubscriptionOption | SubscriptionHeader;
type DataBlockState = { [productId: string]: number; };

const EditActionsPopup = (props) => {
    const { loading, getAvailableProductsForAccount, open, setOpen, confirmDialog, setConfirmDialog, row, setRow, handleEdit, serviceLine,
        onSave, starlinkService, starlinkFunction, pauseData, setPauseData, endNow, handleChangeEndNow, rejectReason, setRejectReason, product,
        setProduct, handleChangeProduct, availableProducts, handlePauseResume, optInData, setOptInData, allNonAdminPermissions, topUpStandardServiceLine,
        mobilePriority, setMobilePriority, handleOptIn, availableCustomPlans, assignCustomPlan, assignCustomplan, authReducer, location, handleChangeServiceLine, addTopUpToStandardServiceLine,
        getStarlinkMapTelemetry, starlinkMapTelemetry, updatePublicIP, getNonAdminPermissions, getTopUpProductIds, standardTopUpProducts, getServicelineTerminalRouter
    } = props;
    const dispatch = useDispatch();
    const _userOu: any = JSON.parse(getDataFromLocalStorage(USER_OU) || "{}");
    const STARLINK_ADMIN_SF = "starlink-admin";
    const STARLINK_FULL_SF = "starlink-full";
    const STARLINK_ACCESS_SF = "starlink-only-user";
    const starlinkFullService = SERVICE_FUNCTION_TO_FEATURE[STARLINK_FULL_SF]["service"];
    const starlinkFullFunction = SERVICE_FUNCTION_TO_FEATURE[STARLINK_FULL_SF]["function"];
    const starlinkAccessService = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ACCESS_SF]["service"];
    const starlinkAccessFunction = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ACCESS_SF]["function"];
    const starlinkAdminService = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["service"];
    const starlinkAdminFunction = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["function"];

    useEffect(() => {
        getNonAdminPermissions({ dpId: authReducer?.selectedOu?.id, parentDpId: _userOu?.id })
        getTopUpProductIds({ serviceLineNumber: row?.serviceLineNumber })
    }, [])

    const [selectedOu, setSelectedOu] = useState(authReducer?.selectedOu?.id)
    const [openConfirmPopup, setOpenConfirmPopup] = useState({ open: false, title: "", subTitle: "", confirmAction: () => { }, cancelAction: () => { }, confirmButton: "", data: null })
    const isAdmin = checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction);
    const isFull = checkLoggedInUserAuthorizedToViewPage(starlinkFullService, starlinkFullFunction);
    const isAccess = checkLoggedInUserAuthorizedToViewPage(starlinkAccessService, starlinkAccessFunction);
    const [isTopUpSame, setIsTopUpSame] = useState(true);
    const [isAssigning, setIsAssigning] = useState(false);
    const getAction = (condition, permission, action) => condition && permission?.allowed ? action : null;

    const deviceActionsList = useMemo(() => {
        return [
            isAdmin && STARLINK_ADMIN_SL_DETAILS,
            isAdmin && STARLINK_ADMIN_SL_CHNAGE_SUB_ORG,
            getAction(isAdmin, allNonAdminPermissions["starlinkAdminAccess"]?.mobilePriority, STARLINK_ADMIN_SL_MOBILE_PRIORITY),
            getAction(isFull, allNonAdminPermissions["starlinkFullAccess"]?.mobilePriority, STARLINK_ADMIN_SL_MOBILE_PRIORITY),
            getAction(isAccess && !isAdmin && !isFull, allNonAdminPermissions["starlinkAccess"]?.mobilePriority, STARLINK_ADMIN_SL_MOBILE_PRIORITY),
            getAction(isAdmin, allNonAdminPermissions["starlinkAdminAccess"]?.pauseServicePlans, row?.subscriptionActiveStatus === "active" ? STARLINK_ADMIN_SL_PAUSE_SERVICE_LINE : STARLINK_ADMIN_SL_RESUME_SERVICE_LINE),
            getAction(isFull, allNonAdminPermissions["starlinkFullAccess"]?.pauseServicePlans, row?.subscriptionActiveStatus === "active" ? STARLINK_ADMIN_SL_PAUSE_SERVICE_LINE : STARLINK_ADMIN_SL_RESUME_SERVICE_LINE),
            getAction(isAccess && !isAdmin && !isFull, allNonAdminPermissions["starlinkAccess"]?.pauseServicePlans, row?.subscriptionActiveStatus === "active" ? STARLINK_ADMIN_SL_PAUSE_SERVICE_LINE : STARLINK_ADMIN_SL_RESUME_SERVICE_LINE),
            getAction(isAdmin, allNonAdminPermissions["starlinkAdminAccess"]?.servicePlan, SERVICE_PLAN),
            getAction(isFull, allNonAdminPermissions["starlinkFullAccess"]?.servicePlan, SERVICE_PLAN),
            getAction(isAccess && !isAdmin && !isFull, allNonAdminPermissions["starlinkAccess"]?.servicePlan, SERVICE_PLAN),
            isAdmin && row?.isCustomPlan && STARLINK_ADMIN_SL_TOP_UP,
            STARLINK_ADMIN_DEVICES,
            getAction(isAdmin, allNonAdminPermissions["starlinkAdminAccess"]?.publicIp, STARLINK_ADMIN_PUBLIC_IP),
            getAction(isFull, allNonAdminPermissions["starlinkFullAccess"]?.publicIp, STARLINK_ADMIN_PUBLIC_IP),
            getAction(isAccess && !isAdmin && !isFull, allNonAdminPermissions["starlinkAccess"]?.publicIp, STARLINK_ADMIN_PUBLIC_IP),
            // isAdmin && STARLINK_ADMIN_ROUTERS,
            isAdmin &&  STARLINK_ADMIN_BETA_DEVICES,
        ].filter(Boolean);
    }, [row, allNonAdminPermissions]);

    const [selectedPlan, setSelectedPlan] = useState<any>(null)
    const [migrationConfirm, setMigrationConfirm] = useState(false)
    const [formattedSubscriptionDetails, setFormattedSubscriptionDetails] = useState<any>([]);
    const [selectedAccount, setSelectedAccount] = useState<any>(null)
    const [selectedTerminal, setSelectedTerminal] = useState<any>(null)
    const [updatedName, setUpdatedName] = useState<any>(null)
    const [selectedPlanSize, setSelectedPlanSize] = useState<any>(null)
    const [downgradePopup, setDowngradePopup] = useState(false)
    const [allowDowngradeNow, setAllowDowngradeNow] = useState(true);
    const [planMobilePriority, setPlanMobilePriority] = useState('optIn')
    const [publicIpEnabled, setPublicIpEnabled] = useState<boolean>(row?.publicIp || false)
    const [serviceLineAction, setServiceLineAction] = useState('resume')
    const [dataBlocksCurrent, setDataBlocksCurrent] = useState<DataBlockState>({});
    const [dataBlocksNext, setDataBlocksNext] = useState<DataBlockState>({});
    const [topUpDataBlocks, setTopUpDataBlocks] = useState<DataBlockState>({});
    const [dataBlockAll, setDataBlockAll] = useState<DataBlockState>({})
    const [planOnServiceLine, setPlanOnServiceLine] = useState({})
    const [planOnServiceLineNext, setPlanOnServiceLineNext] = useState({})
    const [topUpOnServiceLine, setTopUpOnServiceLine] = useState({})

    useEffect(() => {
        const formattedPlans: any = [];
        let customPlans: PlanDropdownOption[] = [];

        if (row?.data_block_product_details) {
            //all data blocks
            const dataBlockAll = row?.data_block_product_details?.reduce((acc, item) => {
                acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count;

                return acc;
            }, {});

            setDataBlockAll(dataBlockAll)
            //current excluding topup
            const currDataBlock = row?.data_block_product_details?.reduce((acc, item) => {
                if (item?.type === "CurrentBillingCycle" && item.product_type !== 'topUpProduct') {
                    acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count;
                }
                return acc;
            }, {});
            setDataBlocksCurrent(currDataBlock)

            // next month
            const dataBlockNext = row?.data_block_product_details?.reduce((acc, item) => {
                if (item?.type === "NextBillingCycle") {
                    acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count;
                }
                return acc;
            }, {});
            setDataBlocksNext(dataBlockNext)

            //current month topup
            let topupdataBlock = row?.data_block_product_details?.reduce((acc, item) => {
                if (item?.type === "CurrentBillingCycle" && item.product_type === 'topUpProduct') {
                    acc[item.product_id] = (acc[item.product_id] || 0) + item.count;
                }
                return acc;
            }, {});
            setTopUpDataBlocks(topupdataBlock);
        }

        if (availableCustomPlans?.custom_plans?.length) {
            customPlans = availableCustomPlans.custom_plans.map((subscription, index) => ({
                ...subscription,
                label: subscription.plan_name,
                name: subscription.plan_name,
                data: subscription.details,
                isCustomPlan: true,
                hasDivider: index === availableCustomPlans.custom_plans.length - 1
            }));
        }

       const groupedCustomPlans: Record<string, SubscriptionOption[]> = {};

        if (availableCustomPlans?.custom_plans?.length) {
            availableCustomPlans.custom_plans.forEach(subscription => {
                const accountNumber =
                    subscription?.details?.[0]?.account_number || 'UNKNOWN';

                if (!groupedCustomPlans[accountNumber]) {
                    groupedCustomPlans[accountNumber] = [];
                }

                groupedCustomPlans[accountNumber].push({
                    ...subscription,
                    label: subscription.plan_name,
                    name: subscription.plan_name,
                    data: subscription.details,
                    isCustomPlan: true
                });
            });
        }


        const groupedStandardPlans: Record<string, SubscriptionOption[]> = {};
        if (availableCustomPlans?.available_products?.length) {
            for (const subscription of availableCustomPlans.available_products) {
                const accountNumber = subscription.plan_details?.[0]?.account_number || 'UNKNOWN';
                const maskedAccount = accountNumber !== 'UNKNOWN' ? `${accountNumber}` : 'UNKNOWN';

                if (!groupedStandardPlans[maskedAccount]) {
                    groupedStandardPlans[maskedAccount] = [];
                }

                groupedStandardPlans[maskedAccount].push({
                    ...subscription,
                    label: `${subscription.name} • US $${subscription.price} • ${subscription.iso_currency_code}`,
                    name: subscription.name,
                    data: subscription.plan_details,
                    isCustomPlan: false
                });
            }
        }
        // formattedPlans.push({ label: 'Custom Plans', name: 'Custom Plans', data: [] }, ...customPlans);
        if (Object.keys(groupedCustomPlans).length > 0) {
            formattedPlans.push({ label: 'Custom Plans', name: 'Custom Plans', data: [] });

            Object.entries(groupedCustomPlans).forEach(([account, plans]) => {
                formattedPlans.push({ label: `Account ${account}`, name: `Account ${account}`, data: [] });

                plans.forEach((plan, index) => {
                    formattedPlans.push({
                        ...plan,
                        hasDivider: index === plans.length - 1
                    });
                });
            });
}

        if (Object.keys(groupedStandardPlans).length > 0) {
            formattedPlans.push({ label: 'Standard Plans', name: 'Standard Plans', data: [] });

            Object.entries(groupedStandardPlans).forEach(([account, plans]) => {
                formattedPlans.push({ label: `Account ${account}`, name: `Account ${account}`, data: [] });

                plans.forEach((plan, index) => {
                    formattedPlans.push({
                        ...plan,
                        hasDivider: index === plans.length - 1
                    });
                });
            });
        }
        setFormattedSubscriptionDetails(formattedPlans)

        if (row?.isCustomPlan) {
            const matchedPlan = formattedPlans?.find(item => item?.name?.trim() === row?.servicePlan?.trim());
            setSelectedPlan(matchedPlan);
            setSelectedPlanSize({ planSize: matchedPlan?.plan_size, planUnit: matchedPlan?.unit });
        } else {
            let matchedPlan: any = null;
            for (let i = 0; i < formattedPlans?.length; i++) {
                if (formattedPlans[i]?.plan_details && formattedPlans[i]?.plan_details?.length > 0 && formattedPlans[i]?.plan_details[0]?.product_reference_id === row?.productReferenceId) {
                    matchedPlan = formattedPlans[i]
                }
            }
            setSelectedPlan(matchedPlan);
            setSelectedPlanSize({ planSize: matchedPlan?.plan_size, planUnit: matchedPlan?.unit });
        }
        if (row?.publicIp && row?.userTerminalDetails?.[0]?.userTerminalId) {
            getStarlinkMapTelemetry({
                userTerminalId: "ut" + row.userTerminalDetails[0].userTerminalId
            });
        }
    }, [row, availableCustomPlans])

    useEffect(() => {
        if (selectedPlan) {
            setSelectedAccount(selectedPlan?.data && selectedPlan?.data?.length > 0 && selectedPlan?.data[0]?.account_number)
            setSelectedTerminal(row?.userTerminals && row?.userTerminals)
        }
    }, [selectedPlan])

    const handleChangeUsageType = (value) => {
        setTopUpOnServiceLine(topUpDataBlocks)
        setPlanOnServiceLine(dataBlocksCurrent)
        setPlanOnServiceLineNext(dataBlocksNext)
        setDataBlocksCurrent({})
        setTopUpDataBlocks({})
        setDataBlocksNext({})
        if (value?.data && value?.data?.length > 0 && value?.data[0]?.product_reference_id === row?.productReferenceId) {
            setDataBlocksCurrent(planOnServiceLine)
            setTopUpDataBlocks(topUpOnServiceLine)
            setDataBlocksNext(planOnServiceLineNext)
        }
        setSelectedPlan(value)
    }

    const assignPlan = () => {
        if (isAssigning) return;
        setIsAssigning(true);
        try {
           
          let finalDataBlock 
          if(row?.servicePlan?.trim() !== selectedPlan?.name?.trim()){
            //global to local
             if (row?.price < selectedPlan?.price) { 
                finalDataBlock = dataBlocksCurrent
             }else {
                //local to global
                finalDataBlock = dataBlocksNext 
             }
             
          }else{
              if(isDifferent(row?.data_block_product_details?.reduce((acc, item) => { if (item.type === 'CurrentBillingCycle' && item.product_type !== 'topUpProduct') { acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count; } return acc; }, {}), dataBlocksCurrent)){
                finalDataBlock = dataBlocksCurrent
            }else{
                finalDataBlock = dataBlocksNext
            }
          }
                const dataBlockProducts = Object.entries(finalDataBlock)
                .map(([productId, count]) => ({
                    productId,
                    count
                }))
                .filter((item:any) => item.count > 0);
            if (!selectedPlan?.isCustomPlan && (_.isEmpty(dataBlockProducts) || Object.values(dataBlockProducts).every(val => val.count === 0))) {
                 const product_ref = selectedPlan?.plan_details?.[0]?.product_reference_id;
               if (!(row?.productReferenceId && product_ref && row.productReferenceId === product_ref)) {
                        return;
                    }
            }
            let params = {
                serviceLineNumber: row?.serviceLineNumber,
                customPlanId: selectedPlan?.details && selectedPlan?.details?.length > 0 ? selectedPlan?.details[0]?.custom_plan_id : "",
                accountNumber: selectedAccount,
                userTerminalId: selectedTerminal.split(','),
                organizationId: selectedOu,
                productReferenceId: selectedPlan?.plan_details && selectedPlan?.plan_details?.length > 0 ? selectedPlan?.plan_details[0]?.product_reference_id : "",
                allowDowngradeNow: !allowDowngradeNow,
                dataBlockProducts: dataBlockProducts,
                action: planMobilePriority,
                pauseServiceLine: serviceLineAction === 'pause' ? true : false 
            }
            assignCustomPlan(params)
        } catch (error) {
            console.error("Error assigning plan:", error);
        } finally {
            // setIsAssigning(false);
        }
    }

    const handleAssignPlan = async () => {
        if (selectedPlan && selectedPlan?.data && selectedPlan?.data?.length > 0) {
            let planAccount = selectedPlan?.data[0]?.account_number
            let slAccount = row?.accountNumber
            if (planAccount === slAccount) {
                assignPlan()
            } else {
                setMigrationConfirm(true)
            }
            setDowngradePopup(false)
        }
    }

    const handleResumeAssignPlan = async () => {
        if (!selectedPlan || isAssigning) return;
        setIsAssigning(true);
        try {
            const dataBlockProducts = Object.entries(dataBlocksCurrent || {})
                .map(([productId, count]) => ({ productId, count }))
                .filter((item: any) => item.count > 0);

            if (!selectedPlan?.isCustomPlan && !selectedPlan?.name?.includes('Pooled') && dataBlockProducts.length === 0) {
                return;
            }

            const params = {
                serviceLineNumber: row?.serviceLineNumber,
                accountNumber: selectedPlan?.data?.[0]?.account_number || row?.accountNumber,
                userTerminalId: (row?.userTerminals || '').split(','),
                organizationId: selectedOu,
                customPlanId: selectedPlan?.isCustomPlan ? selectedPlan?.details?.[0]?.custom_plan_id : '',
                productReferenceId: !selectedPlan?.isCustomPlan ? selectedPlan?.plan_details?.[0]?.product_reference_id : '',
                allowDowngradeNow: false, 
                dataBlockProducts: dataBlockProducts,
                action: 'optIn',
                pauseServiceLine: false,
            };
            await assignCustomPlan(params);
            handleClose();
            handleChangeServiceLine();
        } catch (error) {
            console.error("Error resuming service line:", error);
        } finally {
            setIsAssigning(false);
        }
    }

    const handleCancelScheduledPlan = async () => {
        try{
            let params = {
                serviceLineNumber: row?.serviceLineNumber
            }
            setOpenConfirmPopup({ open: true, title: "Cancel Scheduled Plan", subTitle: "Are you sure you want to cancel the scheduled plan.", 
                confirmAction: async () => { 
                    await dispatch(cancelScheduledPlan(params)) 
                    handleClose()
                }, cancelAction: () => { }, confirmButton: "OK", data: null })
        } catch(err){
            console.log("Error in cancelling schedulesd Plan.")
        }
    }

    const getIdNameForList = (action) => {
        if (action == STARLINK_ADMIN_SL_CHNAGE_SUB_ORG) {
            if (checkLoggedInUserAuthorizedToViewPage(starlinkService, starlinkFunction)) {
                return 'actionType-enabled';
            }
        } else if (action == STARLINK_ADMIN_SL_DETAILS) {
            if (checkLoggedInUserAuthorizedToViewPage(starlinkService, starlinkFunction)) {
                return 'actionType-enabled';
            }
        }
        // else if (action == STARLINK_ADMIN_ROUTERS) {
        //     if (checkLoggedInUserAuthorizedToViewPage(starlinkService, starlinkFunction)) {
        //         return 'actionType-enabled';
        //     }
        // }
        else if (action == STARLINK_ADMIN_BETA_DEVICES) {
            if (checkLoggedInUserAuthorizedToViewPage(starlinkService, starlinkFunction)) {
                return 'actionType-enabled';
            }
        }
        else if (action == STARLINK_ADMIN_SL_TOP_UP) {
            if (checkLoggedInUserAuthorizedToViewPage(starlinkService, starlinkFunction)) {
                return 'actionType-enabled';
            }
        }
        else if (action == STARLINK_ADMIN_DEVICES) {
            return 'actionType-enabled';
        }
        else if (action == STARLINK_ADMIN_SL_MOBILE_PRIORITY) {
            if (((checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) && allNonAdminPermissions["starlinkAdminAccess"]?.mobilePriority?.allowed)
                || (checkLoggedInUserAuthorizedToViewPage(starlinkFullService, starlinkFullFunction) && allNonAdminPermissions["starlinkFullAccess"]?.mobilePriority?.allowed)
                || (checkLoggedInUserAuthorizedToViewPage(starlinkAccessService, starlinkAccessFunction) && allNonAdminPermissions["starlinkAccess"]?.mobilePriority?.allowed))) {
                if (row?.accountType !== "credential" || row?.serviceLineStatus) {
                    return 'actionType-enabled';
                }
            }
        } else if (action == STARLINK_ADMIN_SL_PAUSE_SERVICE_LINE || action == STARLINK_ADMIN_SL_RESUME_SERVICE_LINE) {
            if (((checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) && allNonAdminPermissions["starlinkAdminAccess"]?.pauseServicePlans?.allowed)
                || (checkLoggedInUserAuthorizedToViewPage(starlinkFullService, starlinkFullFunction) && allNonAdminPermissions["starlinkFullAccess"]?.pauseServicePlans?.allowed)
                || (checkLoggedInUserAuthorizedToViewPage(starlinkAccessService, starlinkAccessFunction) && allNonAdminPermissions["starlinkAccess"]?.pauseServicePlans?.allowed))) {
                if (row?.accountType !== "credential") {
                    return 'actionType-enabled';
                }
            }
        }
        else if (action == "SERVICE PLAN") {
            if (((checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) && allNonAdminPermissions["starlinkAdminAccess"]?.servicePlan?.allowed)
                || (checkLoggedInUserAuthorizedToViewPage(starlinkFullService, starlinkFullFunction) && allNonAdminPermissions["starlinkFullAccess"]?.servicePlan?.allowed)
                || (checkLoggedInUserAuthorizedToViewPage(starlinkAccessService, starlinkAccessFunction) && allNonAdminPermissions["starlinkAccess"]?.servicePlan?.allowed))) {
                return 'actionType-enabled';
            }
        }
        else if (action == STARLINK_ADMIN_PUBLIC_IP) {
            if (((checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction) && allNonAdminPermissions["starlinkAdminAccess"]?.publicIp?.allowed)
                || (checkLoggedInUserAuthorizedToViewPage(starlinkFullService, starlinkFullFunction) && allNonAdminPermissions["starlinkFullAccess"]?.publicIp?.allowed)
                || (checkLoggedInUserAuthorizedToViewPage(starlinkAccessService, starlinkAccessFunction) && allNonAdminPermissions["starlinkAccess"]?.publicIp?.allowed))) {
                return 'actionType-enabled';
            }
        }
        return 'actionType-disabled';
    }

    const getDefaultActionType = (list) => {
        const actionTypes = list.map(action => {
            if (getIdNameForList(action) == 'actionType-enabled') {
                return action;
            } else {
                return '';
            }
        })
        return actionTypes?.filter(action => action != '')?.length > 0 ? actionTypes?.filter(action => action != '')?.[0] : deviceActionsList[0];
    }
    const [selectedAction, setSelectedAction] = useState(getDefaultActionType(deviceActionsList));

    const lastInitializedRowRef = useRef<string | null>(null);
    const initializedTabsRef = useRef<Record<string, boolean>>({});
    const [lastOptedIn, setLastOptedIn] = useState<boolean | undefined>(undefined);

    const updateActionValues = (action) => {
        if (!row?.serviceLineNumber) return;

        if (lastInitializedRowRef.current !== row?.serviceLineNumber) {
            lastInitializedRowRef.current = row?.serviceLineNumber;
            initializedTabsRef.current = {};
            setLastOptedIn(undefined);
        }

        switch (action) {
            case STARLINK_ADMIN_SL_CHNAGE_SUB_ORG: {
                handleEdit({
                    serviceLineNumber: row?.serviceLineNumber,
                    nickname: row?.serviceLineName
                });
                break;
            }
            case STARLINK_ADMIN_SL_DETAILS: {
                handleEdit({
                    serviceLineNumber: row?.serviceLineNumber,
                    nickname: row?.serviceLineName
                });
                break;
            }
            case STARLINK_ADMIN_DEVICES: {
                break;
            }
            case STARLINK_ADMIN_SL_PAUSE_SERVICE_LINE: {
                setPauseData({ serviceLineNumber: row?.serviceLineNumber, serviceLineName: row?.serviceLineName, accountDpId: row?.accountDpId, accountNumber: row?.accountNumber, action: "Pause", endNow: false });
                break;
            }
            case STARLINK_ADMIN_SL_RESUME_SERVICE_LINE: {
                setPauseData({ serviceLineNumber: row?.serviceLineNumber, serviceLineName: row?.serviceLineName, accountDpId: row?.accountDpId, accountNumber: row?.accountNumber, action: "Resume", endNow: false });
                setSelectedPlan(null);
                setDataBlocksCurrent({});
                setDataBlocksNext({});
                setDataBlockAll({});
                break;
            }
            case STARLINK_ADMIN_PUBLIC_IP: {
                if (!initializedTabsRef.current[STARLINK_ADMIN_PUBLIC_IP]) {
                    initializedTabsRef.current[STARLINK_ADMIN_PUBLIC_IP] = true;
                    setPublicIpEnabled(row?.publicIp || false);
                }
                break;
            }
            case STARLINK_ADMIN_SL_MOBILE_PRIORITY: {
                const needsInit = !initializedTabsRef.current[STARLINK_ADMIN_SL_MOBILE_PRIORITY];
                const rowOptedInChanged = lastOptedIn !== row?.optedIn;
                if (needsInit || rowOptedInChanged) {
                    initializedTabsRef.current[STARLINK_ADMIN_SL_MOBILE_PRIORITY] = true;
                    setLastOptedIn(row?.optedIn);
                    setOptInData({
                        serviceLineNumber: row?.serviceLineNumber,
                        serviceLineName: row?.serviceLineName,
                        accountDpId: row?.accountDpId,
                        accountNumber: row?.accountNumber,
                        action: row?.optedIn ? "optOut" : "optIn"
                    });
                    setMobilePriority(row?.optedIn ? true : false);
                }
                break;
            }
            default: setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false })
        }
    }

    useEffect(() => {
        updateActionValues(selectedAction);
    }, [selectedAction, row?.optedIn, row?.serviceLineNumber])

    const handleChangeActionType = (actionType) => {
        setSelectedAction(actionType);
        selectedAction != actionType && setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false });
    }

    const handleConfirmClick = () => {
        confirmDialog.onConfirm();
    }

    useEffect(() => {
        if (!_.isEmpty(topUpDataBlocks) && !_.isEmpty(row?.data_block_product_details)) {
            const topUpEntries = row.data_block_product_details.filter(
                item => item.product_type === 'topUpProduct'
            );

            const topUpMap = topUpEntries.reduce((acc, item) => {
                acc[item.product_id] = item.count;
                return acc;
            }, {});

            let isSame = true;
            for (const [productId, count] of Object.entries(topUpDataBlocks)) {
                if (topUpMap[productId] !== count) {
                    isSame = false;
                    break;
                }
            }

            if (isSame) {
                for (const key of Object.keys(topUpMap)) {
                    if (!(key in topUpDataBlocks)) {
                        isSame = false;
                        break;
                    }
                }
            }
            setIsTopUpSame(isSame);
        } else {
            setIsTopUpSame(false);
        }
    }, [topUpDataBlocks]);

    const handleClose = () => {
        setOpen(false);
        setSelectedAction('');
        setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false });
        // setRow({});
        setPauseData({});
        setProduct('');
        setOptInData({});
        setUpdatedName(null)
        setDataBlocksCurrent({})
        setDataBlocksNext({})
        setTopUpDataBlocks({})
        dispatch({ type: ACTION_TYPES.GET_ROUTERS_PER_TERMINAL, payload: [] });
    }

    const changeSLName = (name) => {
        setUpdatedName(name)
        handleChangeServiceLine()
    }

    const checkDowngradablePlan = () => {
        if (selectedPlan?.unit === selectedPlanSize?.planUnit) {
            return selectedPlan?.plan_size < selectedPlanSize?.planSize
        } else {
            let convertedPlan = selectedPlan?.plan_size ? selectedPlan?.plan_size : 0, convertedSelectedPlan = selectedPlanSize?.planSize ? selectedPlanSize?.planSize : 0;
            if (selectedPlan?.unit === "tb") {
                convertedPlan = selectedPlan?.plan_size * 1000
            }

            if (selectedPlanSize?.planUnit === "tb") {
                convertedSelectedPlan = selectedPlanSize?.planSize * 1000
            }
            return convertedPlan < convertedSelectedPlan
        }
    }

    const handleChangeImmediateDowngrade = (event) => {
        setAllowDowngradeNow(event.target.value === "Yes" ? true : false)
    };

    const handleChangePlanMobilePriority = (event) => {
        setPlanMobilePriority(event.target.value)
    }

    const handleChangeServiceLineAction = (event) => {
        setServiceLineAction(event.target.value)
    }

    const handlePublicIP = async (value) => {
        let params = {
            serviceLineNumber: row?.serviceLineNumber,
            publicIP: value,
            organizationId: row?.accountDpId,
            accountNumber: row?.accountNumber
        }
        await updatePublicIP(params)
    }

    const isDifferent = (obj1: Record<string, any> = {}, obj2: Record<string, any> = {}): boolean => {
        const keys = Object.keys(obj1).concat(Object.keys(obj2).filter(k => !(k in obj1)));
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (obj1[key] !== obj2[key]) {
                return true;
            }
        }
        return false;
    };

    const handleTopUp = () => {
        if (standardTopUpProducts && standardTopUpProducts?.length > 0 && !_.isEmpty(topUpDataBlocks)) {
            let params = {
                organizationId: selectedOu ? selectedOu : "",
                accountNumber: row?.accountNumber,
                credentialId: row?.credentialId,
                serviceLineNumber: row?.serviceLineNumber,
                productReferenceId: standardTopUpProducts[0]?.product_reference_id,
                topupBlockProducts: Object.entries(topUpDataBlocks).map(([productId, count]) => ({
                    productId,
                    count
                }))
            }
            topUpStandardServiceLine(params)
        }
    }

    useEffect(() => {
        if (!_.isEmpty(addTopUpToStandardServiceLine)) {
            toast.success(`Top Up added successfully.`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            dispatch({ type: ACTION_TYPES.ADD_TOPUP_TO_STANDARD_SERVICE_LINE, payload: {} });
            handleClose()
        }
    }, [addTopUpToStandardServiceLine])

    useEffect(() => {
        if (!_.isEmpty(assignCustomplan)) {
            toast.success(`Plan Assigned Successfully`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            setIsAssigning(false);
            dispatch({ type: ACTION_TYPES.ASSIGN_CUSTOM_PLAN, payload: {} });
            handleClose()
        }
    }, [assignCustomplan])

    useEffect(() => {
        getServicelineTerminalRouter({serviceLineNumber: row?.serviceLineNumber})
    },[row])

    return (
        <div className="Form">
            <Dialog
                disableEnforceFocus
                open={open}
                onClose={handleClose}
                aria-labelledby='form-dialog-title'
                fullWidth={true}
                maxWidth={'md'}
                className='config-deploy-starlink-popup menuScroll inventory-warehouse-register-pop-up inventory-edit-actions-container servicelinePopupWidth'
                style={{maxWidth: "800px"}}
            >
                <div style={{height: "480px", overflowY: "hidden"}}>
                    <DialogTitle className='create-default-config-title edit-actions-title headerPadding'>
                        <div>
                            <span>Operations</span>
                            <span className="selected-site-device starlink-admin-operations-popup-service-line-name">{`Service Line: ${updatedName || (row ? row.serviceLineName : 'N/A')}`}</span>
                        </div>
                        <div>
                            {loading ? (
                                <div className="commonLoader_NewSummary wan-profile-interfaces-loader editActions-loader">
                                    <Loader radius={4} length={5} lines={10} width={2} color={"#264C86"} />
                                </div>
                            ) : null}
                            <img src={close} title="Close" onClick={handleClose} />
                        </div>
                    </DialogTitle>
                    <DialogContent className="edit-actions-content">
                        <Grid container spacing={1} style={{margin: "0px"}}>
                            <Grid xs={4} className="menuScroll device-border-right deployed-device-list-starlink" item style={{ maxWidth: "150px", paddingLeft: "0px" }}>
                                <Grid className="device-data-body-starlink ">
                                    <List>
                                        {deviceActionsList && deviceActionsList.map((identifier, index) => {
                                            return <ListItemButton id={getIdNameForList(identifier)} className='status-lists'
                                                style={identifier === selectedAction ? { background: 'rgba(244, 245, 250, 1)' } : { background: '#fff' }}
                                                key={`device-${index}`}
                                                selected={identifier === selectedAction}
                                                onClick={() => getIdNameForList(identifier) == 'actionType-enabled' && handleChangeActionType(identifier)}>
                                                <Typography className={identifier === selectedAction ? "font-status-pop-up selectedAction" : "font-status-pop-up NotselectedAction"}>{identifier}</Typography>
                                            </ListItemButton>
                                        })}
                                    </List>
                                </Grid>
                            </Grid>
                            <Grid item xs={8} className="menuScroll starlinkAdmin-edit-actions-cont" style={{ minHeight: "250px", maxWidth: "650px", flexBasis:"650px", padding: "0px", margin: "0px" }}>
                                <Grid className="device-data-body-starlink edit-actions-data-body">
                                    <Stack className="sub-tab-parent" direction="column" spacing={1}>
                                        {confirmDialog.isOpen && <div className="custom_confirm_dialog_sub_title edit-actions-subTitle">
                                            {confirmDialog.subTitle}
                                            <div className="edit-actions-confirm-btns">
                                                <Divider className="confirm-dialogue-new-divider" />
                                                <div className="confirm-dialogue-new-btns">
                                                    <Button className="confirm-dialogue-cancel" onClick={handleClose}> Cancel </Button>
                                                    <Button className="confirm-dialogue-proceed" onClick={() => handleConfirmClick()}> Proceed </Button>
                                                </div>
                                            </div>
                                        </div>}
                                        {selectedAction == STARLINK_ADMIN_SL_CHNAGE_SUB_ORG && getIdNameForList(selectedAction) == 'actionType-enabled' && <ChangeSubOrg
                                            serviceLine={serviceLine}
                                            open={open} onSave={onSave} onClose={handleClose}
                                            currentDpName={row?.dpName || ''}
                                        />}
                                        {selectedAction == STARLINK_ADMIN_PUBLIC_IP && getIdNameForList(selectedAction) == 'actionType-enabled' ?
                                            <div className="str-plans-row-padding">
                                                <Grid>
                                                    <Grid>
                                                        <span id='edit-toggle-btn-text'>Default</span>
                                                        <Switch className="toggle-btn-edit"
                                                            checked={publicIpEnabled}
                                                            onChange={(e) => { setPublicIpEnabled(e.target.checked); handlePublicIP(e.target.checked); }}
                                                            inputProps={{ 'aria-label': 'controlled' }}
                                                            size="small"
                                                        />
                                                        <span id='edit-toggle-btn-text'>Public IP</span>
                                                    </Grid>
                                                </Grid>
                                                {row?.publicIp &&
                                                    <Box className="starlink-serviceline-details-container str-plans-row-padding">
                                                        <Box className="starlink-serviceline-details-row">
                                                            <Box className="starlink-serviceline-details-heading">Public IPv4</Box>
                                                            <Box className="starlink-serviceline-details-value">{starlinkMapTelemetry && starlinkMapTelemetry?.length > 0 && starlinkMapTelemetry[0]?.ipv4_str}</Box>
                                                        </Box>

                                                        <Box className="starlink-serviceline-details-row">
                                                            <Box className="starlink-serviceline-details-heading">Public IPv6 CPE</Box>
                                                            <Box className="starlink-serviceline-details-value">{starlinkMapTelemetry && starlinkMapTelemetry?.length > 0 && starlinkMapTelemetry[0]?.ipv6_cpe_str}</Box>
                                                        </Box>
                                                        <Box className="starlink-serviceline-details-row">
                                                            <Box className="starlink-serviceline-details-heading">Public IPv6 UE</Box>
                                                            <Box className="starlink-serviceline-details-value">{starlinkMapTelemetry && starlinkMapTelemetry?.length > 0 && starlinkMapTelemetry[0]?.ipv6_ue_str}</Box>
                                                        </Box>
                                                    </Box>}
                                            </div> : null}

                                        {selectedAction == STARLINK_ADMIN_SL_DETAILS && getIdNameForList(selectedAction) == 'actionType-enabled' &&
                                            <ServiceLineDetails serviceLineToUpdate={row} changeSLName={changeSLName} />}

                                        {selectedAction == STARLINK_ADMIN_DEVICES && getIdNameForList(selectedAction) == 'actionType-enabled' &&
                                            <ServiceLineDevices serviceLineToUpdate={row} allNonAdminPermissions={allNonAdminPermissions} changeSLName={changeSLName} userTerminalData={availableCustomPlans} />}

                                        {selectedAction == STARLINK_ADMIN_SL_MOBILE_PRIORITY &&
                                            <MobilePriority setMobilePriority={setMobilePriority} mobilePriority={mobilePriority} optInData={optInData} handleOptIn={handleOptIn} row={row} />}

                                        {selectedAction == STARLINK_ADMIN_SL_TOP_UP && getIdNameForList(selectedAction) == 'actionType-enabled' && row?.isCustomPlan &&
                                            <ServiceLineTopUp serviceLineToUpdate={row} changeSLName={changeSLName} standardTopUpProducts={standardTopUpProducts} />}
 
                                        {selectedAction == "SERVICE PLAN" && <>
                                            <ServicePlan allowDowngradeNow={allowDowngradeNow} authReducer={authReducer} checkDowngradablePlan={checkDowngradablePlan} dataBlockAll={dataBlockAll} dataBlocksCurrent={dataBlocksCurrent} dataBlocksNext={dataBlocksNext} formattedSubscriptionDetails={formattedSubscriptionDetails} getIdNameForList={getIdNameForList} handleAssignPlan={handleAssignPlan} handleChangeImmediateDowngrade={handleChangeImmediateDowngrade} handleChangeUsageType={handleChangeUsageType} handleClose={handleClose} handleTopUp={handleTopUp} isAdmin={isAdmin} isAssigning={isAssigning} isDifferent={isDifferent} isTopUpSame={isTopUpSame} row={row} selectedAccount={selectedAccount} selectedAction={selectedAction} selectedPlan={selectedPlan} setDataBlockAll={setDataBlockAll} setDataBlocksCurrent={setDataBlocksCurrent} setDataBlocksNext={setDataBlocksNext} setDowngradePopup={setDowngradePopup} setOpenConfirmPopup={setOpenConfirmPopup} setSelectedAccount={setSelectedAccount} setTopUpDataBlocks={setTopUpDataBlocks} standardTopUpProducts={standardTopUpProducts} topUpDataBlocks={topUpDataBlocks} serviceLineAction={serviceLineAction} handleChangeServiceLineAction={handleChangeServiceLineAction} planMobilePriority={planMobilePriority} handleChangePlanMobilePriority={handleChangePlanMobilePriority} handleCancelScheduledPlan={handleCancelScheduledPlan}/>
                                        </>
                                        }

                                        {
                                        // selectedAction == STARLINK_ADMIN_ROUTERS && <>
                                        //     <TerminalRouters serviceLineToUpdate={row} changeSLName={changeSLName} standardTopUpProducts={standardTopUpProducts} />
                                        // </>
                                        }
                                        {selectedAction == STARLINK_ADMIN_BETA_DEVICES && <>
                                            <DevicesTab serviceLineToUpdate={row} changeSLName={changeSLName} standardTopUpProducts={standardTopUpProducts} userTerminalData={availableCustomPlans}  />
                                        </>
                                        }

                                        {(selectedAction == STARLINK_ADMIN_SL_PAUSE_SERVICE_LINE || selectedAction == STARLINK_ADMIN_SL_RESUME_SERVICE_LINE) && getIdNameForList(selectedAction) == 'actionType-enabled' &&
                                            <PauseResumeServiceLine
                                                pauseData={pauseData} rejectReason={rejectReason} setRejectReason={setRejectReason}
                                                endNow={endNow} handleChangeEndNow={handleChangeEndNow}
                                                handlePauseResume={handlePauseResume} handleClose={handleClose}
                                                formattedSubscriptionDetails={formattedSubscriptionDetails}
                                                selectedPlan={selectedPlan}
                                                handleChangeUsageType={handleChangeUsageType}
                                                dataBlocksCurrent={dataBlocksCurrent}
                                                setDataBlocksCurrent={setDataBlocksCurrent}
                                                setDataBlockAll={setDataBlockAll}
                                                isAdmin={isAdmin}
                                                handleResumeAssignPlan={handleResumeAssignPlan}
                                                isAssigning={isAssigning}
                                            />
                                        }
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                    </ DialogContent>
                </div>
            </Dialog>

            <Dialog PaperProps={{
                sx: {
                    width: '500px',
                    maxWidth: '500px'
                }
            }} open={openConfirmPopup?.open} onClose={() => { setOpenConfirmPopup({ open: false, title: "", subTitle: "", confirmAction: () => { }, cancelAction: () => { }, confirmButton: "", data: null }) }}>
                <DialogTitle>{openConfirmPopup?.title}</DialogTitle>
                <DialogContent>
                    <Typography> {openConfirmPopup?.subTitle} </Typography>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmPopup({ open: false, title: "", subTitle: "", confirmAction: () => { }, cancelAction: () => { }, confirmButton: "", data: null })} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => { openConfirmPopup?.confirmAction(); setOpenConfirmPopup({ open: false, title: "", subTitle: "", confirmAction: () => { }, cancelAction: () => { }, confirmButton: "", data: null }) }}
                        variant="contained"
                        color="primary"
                    >
                        {openConfirmPopup?.confirmButton}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog PaperProps={{
                sx: {
                    width: '500px',
                    maxWidth: '500px'
                }
            }} open={migrationConfirm} onClose={() => { setMigrationConfirm(false) }}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <Typography> Following Terminals will be moved from {row?.accountNumber} to {selectedPlan?.data[0]?.account_number}: </Typography>

                    {row?.userTerminals ?
                        <ListItem key={row?.userTerminal}>
                            <ListItemText primary={row?.userTerminals} secondary={`Starlink Id: ${row?.userTerminalIds ? row?.userTerminalIds : "-"}`} />
                        </ListItem> : <></>}
                    <ListItem key={row?.userTerminal}>
                        <ListItemText primary={"Plan"} secondary={` ${selectedPlan?.name || row?.name || ""}`} />
                    </ListItem>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setMigrationConfirm(false)} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => { assignPlan(); setMigrationConfirm(false) }}
                        variant="contained"
                        color="primary"
                    >
                        {'Migrate & Assign Plan'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog PaperProps={{
                sx: {
                    width: '500px',
                    maxWidth: '500px'
                }
            }} open={downgradePopup} onClose={() => { setDowngradePopup(false) }}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <Typography> This Plan update will take effect from next billing cycle. </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setDowngradePopup(false); setSelectedPlan(formattedSubscriptionDetails?.find((item) => {
                            return item?.name?.trim() === row?.servicePlan?.trim()
                        }
                        ));
                    }} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => { handleAssignPlan() }}
                        variant="contained"
                        color="primary"
                    >
                        PROCEED
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

const mapStateToProps = (state) => ({
    loading: state.starlinkAdmin.subcribingServiceLine,
    authReducer: state.authReducer,
    allNonAdminPermissions: state.starlinkAdmin.allNonAdminPermissions,
    standardTopUpProducts: state.starlinkAdmin.standardTopUpProducts,
    starlinkMapTelemetry: state.starlinkDashboard.starlinkMapTelemetry,
    addTopUpToStandardServiceLine: state.starlinkAdmin.addTopUpToStandardServiceLine,
    assignCustomplan: state.starlinkAdmin.assignCustomplan,
});

export default withRouter(
    connect(mapStateToProps, { getAvailableProductsForAccount, topUpStandardServiceLine, assignCustomPlan, getStarlinkMapTelemetry, updatePublicIP, getNonAdminPermissions, getTopUpProductIds, getServicelineTerminalRouter })(EditActionsPopup)
);